module.exports = __webpack_public_path__ + "fbaa0574e08378cdb8ec877fa6a482ba.png";